export const removeUndefinedKeys = obj => {
  const newObj = {}
  Object.assign(newObj, obj)
  Object.keys(newObj).forEach(
    key =>
      (newObj[key] === undefined || newObj[key] === null) && delete newObj[key],
  )
  if (Object.keys(newObj).length === 0) {
    return null
  }
  return newObj
}
